// extracted by mini-css-extract-plugin
export var active = "scrollSocialProof-module--active--68ba5";
export var arrowButton = "scrollSocialProof-module--arrowButton--3c6ee";
export var attribution = "scrollSocialProof-module--attribution--003ff";
export var buttonContainer = "scrollSocialProof-module--buttonContainer--9da1c";
export var card = "scrollSocialProof-module--card--8baed";
export var cardContainer = "scrollSocialProof-module--cardContainer--5d2d8";
export var credit = "scrollSocialProof-module--credit--62949";
export var customGrid = "scrollSocialProof-module--customGrid--79b60";
export var desktopInLeft = "scrollSocialProof-module--desktopInLeft--e5ca8";
export var desktopInRight = "scrollSocialProof-module--desktopInRight--6de69";
export var desktopOutLeft = "scrollSocialProof-module--desktopOutLeft--90dae";
export var desktopOutRight = "scrollSocialProof-module--desktopOutRight--e77dd";
export var displayCard = "scrollSocialProof-module--displayCard--0e4a8";
export var headline = "scrollSocialProof-module--headline--f9b29";
export var headlineContainer = "scrollSocialProof-module--headlineContainer--89936";
export var hideCard = "scrollSocialProof-module--hideCard--7e4cf";
export var imgContainer = "scrollSocialProof-module--imgContainer--318e2";
export var mobileInLeft = "scrollSocialProof-module--mobileInLeft--d3058";
export var mobileInLeftTitle = "scrollSocialProof-module--mobileInLeftTitle--2dc76";
export var mobileInRight = "scrollSocialProof-module--mobileInRight--56b33";
export var mobileInRightTitle = "scrollSocialProof-module--mobileInRightTitle--4d3c0";
export var mobileOutLeft = "scrollSocialProof-module--mobileOutLeft--f6410";
export var mobileOutLeftTitle = "scrollSocialProof-module--mobileOutLeftTitle--d767d";
export var mobileOutRight = "scrollSocialProof-module--mobileOutRight--95c37";
export var mobileOutRightTitle = "scrollSocialProof-module--mobileOutRightTitle--e990f";
export var navigationButtonContainer = "scrollSocialProof-module--navigationButtonContainer--8ee31";
export var quote = "scrollSocialProof-module--quote--be370";
export var scrollSocialProof = "scrollSocialProof-module--scrollSocialProof--b822d";